// placeInfo: {
//     fullAmount: Number               // Кол-во полных мест
//     discountAmount: Number           // Кол-во льготных мест
// }

import Vue from "vue";

export default {
    namespaced: true,
    state: {
        // Объекты вида:
        // {string} eventId : {object} placeInfo,
        // ...
    },
    getters: {
        getPlaces(state) {
            return state;
        },
        getPlacesByEventId: state => ({id}) => state[parseInt(id)],
        isValid(state) {
            return Object.values(state)
                .some(item => item.full || item.discount)
        }
    },
    mutations: {
        addPlacesInfo(state, {eventId}) {
            Vue.set(state, eventId, {
                full: 0,
                discount: 0,
            })
        },
        removePlacesInfo(state, event) {
            Vue.delete(state, event.id);
        },
        updatePlaces(state, {eventId, full, discount}) {
            state[eventId].full = full;
            state[eventId].discount = discount;
        },
        clearPlaces(state) {
            for (const eventId in state) {
                Vue.delete(state, eventId);
            }
        },
    },
    actions: {
        updatePlaces({commit, dispatch}, {eventId, full, discount}) {
            commit('updatePlaces', {eventId, full, discount});
            dispatch('config/saveStateToLocalStorage', null, {root: true});
        },
        clearPlaces({commit, dispatch}) {
            commit('clearPlaces');
            dispatch('config/saveStateToLocalStorage', null, {root: true});
        }
    }
}
